import "../../App.css";
import React from "react";
import TEETH_WHITENING from '../Teeth_Whitening'
import CONTACT_US from '../footer';
import Accordian from '../../accordian/accordian'
import ScrollArrow from '../ScrollUp';
import BackBtn from '../BackBtn';


function TEETH_WHITENING_Page() {

    return(
    <>  
        <TEETH_WHITENING/>
        <Accordian
         title="Am I a candidate of teeth whitening" 
         content=" You might be a possibility for proficient teeth brightening if you are encountering staining. Make an appointment with us to see whether tooth brightening could be ideal for you. A few patients, for example, the individuals who are pregnant or delicate to brightening specialists, may not be possibility for proficient brightening."
       />
       <Accordian
         title=" What should I expect when I get my teeth brightened" 
         content="  Teeth brightening comprises of an exhaustive polishing and cleaning of the teeth, with all junks deliberately expelled. We will then secure your gums previously applying a brightening operator to the surface of your teeth. The item will be initiated and left on the teeth for a few minutes previously being washed off with water. Your outcomes will differ as per the regular shade of your teeth and level of staining, however it is typical for patients to encounter a helping of a few shades in a solitary visit."
       />
       <Accordian
         title=" What type of post treatment care is required after having my teeth whitened" 
         content=" It is typical to encounter some tooth sensuality following an expert brightening treatment. Relying upon your outcomes and long span teeth brightening objectives, you may be sent home from your methodology with an at-home brightening pack for later utilization."
       />
 <BackBtn/>
         <CONTACT_US/>
         <ScrollArrow/>
   
      
    </>
    )
}
export default TEETH_WHITENING_Page;